// 人员信息
export const peopleright = [
  { label: "国籍", prop: "nationalityDict" },
  { label: "姓名", prop: "name" },
  { label: "性别", prop: "sexDict" },
  { label: "民族", prop: "nationDict" },
  { label: "证件号码", prop: "cardNumber" },
  { label: "出生日期", prop: "birthday" },
  { label: "婚姻状况", prop: "maritalDict" }
];
// 房屋信息
export const houseright = [
  { label: "房屋类别", prop: "houseTypeDict" },
  { label: "房屋性质", prop: "housePropertyDict" },
  { label: "房屋用途", prop: "houseUsage" },
  { label: "居住现状", prop: "houseLiveDict" },
  { label: "房屋面积", prop: "houseSpace" },
  { label: "房屋间数", prop: "houseNumber" },
  { label: "房屋地址", prop: "houseAddress" },
  { label: "产权编号", prop: "houseCode" }
];
// 车辆信息
export const carright = [
  { label: "车牌号", prop: "carNumber" },
  { label: "车辆品牌", prop: "carBrandDict" },
  { label: "车辆类型", prop: "carType" },
  { label: "车身颜色", prop: "carColorDict" },
  { label: "使用性质", prop: "function" },
  { label: "机动车所有人", prop: "prisonId" },
  { label: "证件号码", prop: "cardNumber" },
  { label: "联系电话", prop: "telphone" },
  { label: "户籍行政区划", prop: "carNumber" },
  { label: "户籍详细地址", prop: "carNumber" },
  { label: "初次登记日期", prop: "createTime" },
  { label: "发牌机关", prop: "carOffice" }
];
// 单位信息
export const unitlright = [
  { label: "单位名称", prop: "unitName" },
  { label: "单位类别", prop: "unitTypeDict" },
  { label: "重点单位", prop: "keyunitDict" },
  { label: "经济类型", prop: "economicType" },
  { label: "行业类别", prop: "industryTypeDict" },
  { label: "上级名称", prop: "higherName" },
  { label: "注册资金", prop: "registerMoney" },
  { label: "联系电话", prop: "unitTelphone" },
  { label: "网址", prop: "url" }
];
// 社区信息
export const communityright = [
  { label: "社区名称", prop: "name" },
  { label: "所属街道", prop: "levelName" },
  { label: "经纬度", prop: "latitude" }
];
// 车辆 右侧 从业人员
export const carhouseright = [
  { name: "姓名", prop: "name" },
  { name: "性别", prop: "name" },
  { name: "民族", prop: "name" },
  { name: "出生日期", prop: "name" },
  { name: "电话", prop: "name" },
  { name: "更新时间", prop: "name" }
];
// 房屋 右侧 居住人员
export const housePeople = [
  { name: "姓名", prop: "name" },
  { name: "性别", prop: "name" },
  { name: "民族", prop: "name" },
  { name: "出生日期", prop: "name" },
  { name: "电话", prop: "name" },
  { name: "与房主关系", prop: "name" }
];
// 安防设施
export const securityright = [
  { label: "设施名称", prop: "securityName" },
  { label: "设施类别", prop: "securityTypeDict" },
  { label: "设施型号", prop: "securityModel" },
  { label: "安装地址", prop: "securityAddress" },
  { label: "所属小区", prop: "name" },
  { label: "备注", prop: "comment" }
];
// 实有装备
export const equipmentright = [
  { label: "装备名称", prop: "equipmentName" },
  { label: "资产编号", prop: "equipmentId" },
  { label: "责任人", prop: "prisonId" },
  { label: "联系电话", prop: "telphone" }
];
// 实有力量
export const powerright = [
  { label: "姓名", prop: "name" },
  { label: "性别", prop: "sexDict" },
  { label: "证件号码", prop: "cardNumber" },
  { label: "民族", prop: "nationDict" },
  { label: "文化程度", prop: "educationDict" },
  { label: "居住地址", prop: "houseAddress" },
  { label: "联系电话", prop: "telphone" },
  { label: "更新时间", prop: "updateTime" }
];
// 过人记录
export const passingRecord = [
  { label: "数据类型", prop: "" },
  { label: "所属组织", prop: "" },
  { label: "录入人脸", prop: "" },
  { label: "抓拍人脸", prop: "" },
  { label: "姓名", prop: "" },
  { label: "证件号码", prop: "" },
  { label: "卡号", prop: "" },
  { label: "进/出", prop: "" },
  { label: "门禁点", prop: "" },
  { label: "通行时间", prop: "" }
];
// 过车记录
export const carPassingRecord = [
  { label: "所属组织", prop: "" },
  { label: "车辆图片", prop: "" },
  { label: "车牌号", prop: "" },
  { label: "监控点", prop: "" },
  { label: "进/出", prop: "" },
  { label: "通行时间", prop: "" }
];